import { GetCustomerOrderDocument } from '../../../graphql/camel'
import useCamelQuery, { UseCamelQuery } from '../../../hooks/useCamelQuery'
import useOtherCustomerIds from '../../../hooks/useOtherCustomerIds'

export type UseGetCustomerOrder = UseCamelQuery<typeof GetCustomerOrderDocument>

export const useGetCustomerOrder = ({ orderId }: { orderId: string }): UseGetCustomerOrder =>
  useCamelQuery(GetCustomerOrderDocument, {
    variables: {
      orderId,
      otherCustomerIds: useOtherCustomerIds(),
    },
  })
